/* eslint-disable max-len */
import React, { useContext, useEffect, useState, useCallback } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import UpdateButton from '../../../../../components/UpdateButton'
import Toast from '../../../../../components/Toast'
import WarningMessage from '../../../../../components/WarningMessage'
import TransactionData from '../TransactionData'
import Account from '../Account'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import moment from 'moment'
import { dataService } from '../../../../../services/data.services'
import GlobalContext from '../../../../../components/Context/GloablContext'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AnimatedModel from '../../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt'
import CustomOverLay from '../../../../../components/CustomOverlay'
import { useSelector } from 'react-redux'
import SchemeStudentList from './SchemeStudentList';
import AppliedStudentPreview from './AppliedStudentPreview'

export default function VoucherRTEScholarship() {
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [toastErrorMessage, setToastErrorMessage] = useState('');
    const { setToastmessage, reloadFY, setReloadFY } = useContext(GlobalContext);
    const moment = require('moment');
    const currentDate = moment();
    let formattedDate = '';
    const fy = JSON.parse(localStorage.getItem('FY_details'));
    const fy_start_date = new Date(fy.start_date);
    const fy_end_date = new Date(fy.end_date);
    if ((currentDate >= fy_start_date && currentDate <= fy_end_date)) {
        formattedDate = currentDate.format('MMM DD,YYYY');
    }
    const [state, setState] = useState({ transaction_date: formattedDate, description: "" })
    const [submitSelected, setsubmitSelected] = useState(false)
    const [errorMessage, setErrorMessage] = useState("");
    const [sourceAccount, setSourceAccount] = useState("")
    const [sourceAccountId, setSourceAccountId] = useState("");
    const [sourceAccountNumber, setSourceAccountNumber] = useState("0.00");

    const [destinationAccount, setDestinationAccount] = useState("")
    const [destinationId, setDestinationId] = useState("");
    const [destinationAccountNumber, setDestinationNumber] = useState("0.00");

    const [warningMessage, setWarningMessage] = useState("");
    const [loadingButton, setLoadingButton] = useState(false)
    const [accountNameError, setAccountNameError] = useState(false)
    const [amountError, setAmountError] = useState(false)
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [dateError, setdateError] = useState(false)
    const navigate = useNavigate();
    const [loadingPage, setLoadingPage] = useState(true)
    const { userType } = useSelector((state) => state.auth);

    // Change viewStudentList to a mapping object for multiple ledgers
    const [schemeStudentsData, setSchemeStudentsData] = useState([])
    const [schemeStudentscount, setSchemeStudentsCount] = useState(0)
    const [studentListLoading, setstudentListLoading] = useState(false)
    const [schemeLedgerId, setSchemeLedgerId] = useState(undefined);
    const [appliedAmts, setAppliedAmts] = useState([]); // Added state for current amounts
    const [appliedStudentsList, setAppliedStudentsList] = useState([])
    const [currentTab, setCurrentTab] = useState('step:1'); // Default tab
    const [actionButton, setActionButton] = useState('Next'); // Default tab
    const [disableDate, setDisableDate] = useState(false);
    const voucherSteps = [
        { key: "step:1", label: "Voucher Details" },
        { key: "step:2", label: "Apply to Students" },
        { key: "step:3", label: "Preview" },
    ];

    const [searchParams, setSearchParams] = useSearchParams({ student_page_number: 1 });

    /**
     * The function `handleStep2Validation` checks if a transaction date is empty and if the description
     * length exceeds 100 words, setting error messages accordingly.
     * @returns The `handleStep2Validation` function is returning a boolean value `isValid`, which indicates
     * whether the validation checks passed successfully. If all validation checks pass, `isValid` will
     * be `true`, otherwise it will be `false`.
     */
    const handleStep2Validation = () => {
        setToastErrorMessage("")

        if (schemeStudentsData.length === 0 && appliedStudentsList.length === 0) {
            setToastErrorMessage("No students applicable for the selected ledger. Voucher cannot be added.");
            return false;
        }

        const ledgerAmt = parseFloat(sourceAccountNumber);
        const total = Object.values(appliedAmts).reduce((sum, val) => sum + parseFloat(val || 0), 0);

        if (total === 0) {
            setToastErrorMessage("Apply amount to at least one student");
            return false
        }


        // Check: Received Amt ≤ Pending Amt for each student
        for (let i = 0; i < appliedStudentsList.length; i++) {
            const student = appliedStudentsList[i];
            const pending = parseFloat(student.pending_amount || 0);
            const current = parseFloat(student.applied_amount || 0);
            if (current > pending) {
                setToastErrorMessage(`${student.student_id}: Amt to Apply (${current.toFixed(2)}) cannot be more than Pending Amt (${pending.toFixed(2)})`);
                return false;
            }
        }

        // Check: Total Amt === Ledger Amt
        if (total !== ledgerAmt) {
            setToastErrorMessage('Total Applied Amount must be equal to Voucher Amount');
            return false
        }

        if (Object.keys(appliedStudentsList).length > 100) {
            setToastErrorMessage('Limit reached: Only 100 students can be applied at a time.');
            return false;
        } else {
            setToastErrorMessage('');
        }

        return true;
    }

    /**
     * The function `handleStep1Validation` checks for empty fields, validates amounts, and ensures
     * total amounts match before allowing account validation.
     * @returns The function `handleStep1Validation` is returning a boolean value - either `true` or
     * `false` based on the conditions checked within the function.
     */
    const handleStep1Validation = () => {
        let sourceAccountAmount = parseFloat(sourceAccountNumber || "0.00");
        let destinationAccountAmount = parseFloat(destinationAccountNumber || "0.00");

        if (state.transaction_date === "") {
            setdateError("date-error");
            setToastErrorMessage("Select Transaction Date")
            return false
        }
        if (state.description.length > 100) {
            setToastErrorMessage('Description cannot exceed 100 words')
            return false
        }

        if (sourceAccountId === "" || destinationId === "") {
            setToastErrorMessage("Select Source/Destination Account")
            setAccountNameError(true)
            return false
        } else if (sourceAccountAmount === 0 || destinationAccountAmount === 0) {
            setToastErrorMessage("Amount must be greater than zero")
            setAmountError(true)
            return false
        }
        if (parseFloat(sourceAccountNumber).toFixed(2) !== parseFloat(destinationAccountNumber).toFixed(2)) {
            setToastErrorMessage("Total Source Amount and Destination Amount must be equal")
            return false
        }
        return true
    }
    /**
     * The function `handleApiCall` is an asynchronous function that handles API calls for creating a
     * voucher entry in a financial system, including processing source and destination accounts and
     * displaying appropriate messages based on the API response or errors.
     */
    const handleApiCall = async () => {
        setLoadingButton(true)
        if (!(userType === 'institution-user' || userType === 'institution-admin')) {
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
            if (res.data.data.ongoing !== JSON.parse(localStorage.getItem('FY_details')).name) {
                setToastErrorMessage(`You are not authorized to make entry for the${JSON.parse(localStorage.getItem('FY_details')).name}. Please refresh the page.`)
                return
            }
        }
        try {
            const branch_id = await GetBranchId();
            // Prepare result as required
            const student_scheme_entries = appliedStudentsList.map(student => ({
                scheme_header_id: student.scheme_header_id,
                current_amt: parseFloat(student.applied_amount || 0).toFixed(2),
            }));

            console.log("result", student_scheme_entries);
            let body = {
                "branch_id": branch_id,
                "voucher_type": "RTE-Scholarship",
                "financial_year": JSON.parse(localStorage.getItem('FY_details')).name,
                "transaction_date": moment(state.transaction_date).format('YYYY-MM-DD'),
                "description": state.description,
                "destination_account": destinationAccount,
                "destination_amount": parseFloat(destinationAccountNumber),
                "destination_account_id": destinationId,
                "source_amount": parseFloat(sourceAccountNumber),
                "source_account_id": sourceAccountId,
                "source_account": sourceAccount,
                "student_scheme_entries": student_scheme_entries,
            };
            console.log("body", body);
            let response = await dataService.PostAPI(body, 'voucher-entry');
            navigate("/accounting/voucher-entry")
            setToastmessage(response.data.data.message)
            setLoadingButton(false);
            setActivateButtonLoading(false)
        } catch (error) {
            //setToastErrorMessage(error.response.data.message || error.message || "Something went wrong")
            console.error("An error occurred:", error);
            // Handle error here
            setActivateButtonLoading(false)
            setOpenConfirmation(false)
            setLoadingButton(false); // Consider whether setLoadingButton(false) should be inside or outside the catch block based on your requirements.
        }
    }
    /**
     * The handleSubmit function handles form submission by performing validation, checking account
     * validation, and making API calls based on certain conditions.
     */
    const handleSubmit = async () => {
        let currentTab1 = currentTab;
        let newTabNum = Number(currentTab1.split(':')[1]) + 1
        let newTab = "step:" + newTabNum;
        console.log("newTab", newTab);

        if (newTab === 'step:2' || newTab === 'step:3') {
            handleTabs(newTab);
            return;
        }
        else if (newTab === 'step:4') {

            handleStep1Validation();
            if (!handleStep1Validation()) {
                setLoadingButton(false);
                return
            }
            if (!handleStep2Validation()) {
                setLoadingButton(false);
                setsubmitSelected(true);
                return
            }

            if ((JSON.parse(localStorage.getItem('FY_details')).status === "open")) {
                handelOpenFY()
                return;
            }
            handleApiCall()
        }
    }
    /**
     * The function `handelOpenFY` sets the `activateButtonLoading` state to `false` and the
     * `openConfirmation` state to `true`.
     */
    const handelOpenFY = async () => {
        setActivateButtonLoading(false)
        setOpenConfirmation(true)
    }
    /**
     * The function `handleFYSubmit` sets a loading state for a button and makes an API call.
     */
    const handleFYSubmit = () => {
        setActivateButtonLoading(true)
        handleApiCall()
    }

    const handleSchemeLedger = useCallback(async () => {
        
        let pageNumber = searchParams.get("student_page_number") || "1";
        let search = searchParams.get("search");
        if (schemeLedgerId === undefined) {
            setSchemeStudentsData([]);
            setAppliedAmts([]);
            setAppliedStudentsList([]);
            setSchemeStudentsCount(0);
            setstudentListLoading(false);
            setDisableDate(false);
            return;
        }

        // Assuming branch_id is available in scope or via props/context
        setstudentListLoading(true);
        const branch_id = await GetBranchId();
        let endpoint = `groups-and-ledgers/ledger-scheme-entries?student_page_number=${pageNumber}&branch_id=${branch_id}&scheme_ledger_id=${schemeLedgerId}&voucher_date=` + moment(state.transaction_date).format('YYYY-MM-DD');
        if (search && search.trim() !== "") {
            endpoint += `&search=${encodeURIComponent(search)}`;
        }
        const res =  await dataService.GetAPI(endpoint, true);
        const schemeEntries = res.data.data['students_list'] || [];
        setSchemeStudentsData(schemeEntries);
        setSchemeStudentsCount(res.data.data['total_students_count'] || 0);
        setstudentListLoading(false);
        setDisableDate(true);
    }, [searchParams, schemeLedgerId]);

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, student_page_number: pageNum.selected + 1 });
    };

    useEffect(() => {
        handleSchemeLedger();
    }, [searchParams, schemeLedgerId]);

    useEffect(() => {
        setReloadFY(false)
        setLoadingPage(true)
        setTimeout(() => {
            setLoadingPage(false)
        }, 500);
    }, [reloadFY])

    const handleTabs = (key) => {
        if (key === 'step:1') {
            setActionButton('Next');
        }

        if (key === 'step:2') {
            if (!handleStep1Validation()) {
                setLoadingButton(false);
                return
            }
            setActionButton('Next');
        }
        else if (key === 'step:3') {
            if (!handleStep1Validation()) {
                setLoadingButton(false);
                return
            }
            if (!handleStep2Validation()) {
                setLoadingButton(false);
                setsubmitSelected(true);
                return
            }
            setActionButton('Add');
        }
        setCurrentTab(key);
    }

    return (
        <CardHeader noPadding>
            <>
                <div class="mainDataCntnrTop shadow-s13" style={{ position: "sticky", position: "-webkit-sticky" }}>
                    <h5 class="pageHeader addclass">Add Voucher: RTE/Scholarship</h5>
                    <div class="flex items-center">
                        <UpdateButton
                            ButtonName={"Cancel"}
                            loading={false}
                            handleOnCLick={() => { navigate("/accounting/voucher-entry") }}
                            classKey="cancl-btn"
                        />
                        <UpdateButton
                            loading={loadingButton}
                            ButtonName={actionButton}
                            id={"add_contra"}
                            handleOnCLick={() => { handleSubmit() }}
                            classKey={"actn-btn onboardInstitution"}
                        />
                    </div>
                    {toastErrorMessage !== '' && <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage} />}
                    {warningMessage !== "" && <WarningMessage
                        warningMessage={warningMessage}
                        setWarningMessage={setWarningMessage}
                        fullMessage={true}

                    />}
                </div>
                {loadingPage ? <div><CustomOverLay Active text="Loading ..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`} /></div>
                    : <div className='h-[calc(100vh-70px)]'>
                        <div class='overflow-y-auto scrollBar-hidden pt-[24px] pb-5'>
                            <div className='w-[100%] mx-auto'>
                                <div class="justify-center border-b pb-[10px] block">
                                    <div class="flex items-center justify-center">
                                        <div class="w-[30px] h-[30px] rounded-full border-[6px] border-[#106EB4] bg-[#fff] z-[1]"></div>
                                        <div class={`w-[150px] h-2 -mx-[1px] ${(currentTab === 'step:2' || currentTab === 'step:3') ? 'bg-[#106EB4] ' : 'bg-[#D9D9D9]'}`}></div>
                                        <div class={`w-[30px] h-[30px] rounded-full border-[6px] z-[1] ${(currentTab === 'step:2' || currentTab === 'step:3') ? 'border-[#106EB4]' : 'border-[#D9D9D9]'} bg-[#fff]`}></div>
                                        <div class={`w-[150px] h-2 -mx-[1px] ${(currentTab === 'step:3') ? 'bg-[#106EB4]' : 'bg-[#D9D9D9]'}`}></div>
                                        <div class={`w-[30px] h-[30px] rounded-full border-[6px] z-[1] ${(currentTab === 'step:3') ? 'border-[#106EB4]' : 'border-[#D9D9D9]'} bg-[#fff]`}></div>
                                    </div>
                                    <div class="flex justify-center">
                                        {voucherSteps.map((step, idx) => (
                                            <p onClick={() => { handleTabs(step.key); }}
                                                key={step.key}
                                                className={`pt-[7px] text-f7 cursor-pointer text-[#031624] w-[180px] text-center ${currentTab === step.key ? 'font-semibold' : ''}`}>
                                                {step.label}
                                            </p>
                                        ))}
                                    </div>
                                </div>

                                {currentTab === 'step:1' &&
                                    <div className='overflow-auto scroll-bar min-h-minheight1 max-h-maxheight1 px-[40px] pt-4'>
                                        <TransactionData
                                            state={state}
                                            setToastErrorMessage={setToastErrorMessage}
                                            setsubmitSelected={setsubmitSelected}
                                            submitSelected={submitSelected}
                                            setErrorMessage={setErrorMessage}
                                            setState={setState}
                                            dateError={dateError}
                                            setdateError={setdateError}
                                            disableDate={disableDate}
                                            
                                        />
                                        <div className='flex mt-6 mx-auto justify-center w-[100%]'>
                                            <Account
                                                AccountType={"Source"}
                                                AccountOption={"single"}
                                                setSingleAccount={setSourceAccount}
                                                singleAccount={sourceAccount}
                                                setSingleAccountId={setSourceAccountId}
                                                setSingleAccountNumber={setSourceAccountNumber}
                                                singleAccountNumber={sourceAccountNumber}
                                                singleAccountId={sourceAccountId}
                                                setAccountNameError={setAccountNameError}
                                                accountNameError={accountNameError}
                                                amountError={amountError}
                                                setAmountError={setAmountError}
                                                setToastErrorMessage={setToastErrorMessage}
                                                state={state}
                                                LegerEndpoint={"RTE-Scholarship"}
                                                setSchemeStudentsData={setSchemeStudentsData}
                                                setstudentListLoading={setstudentListLoading}
                                                classKey={"w-[400px]"}
                                                handleSchemeLedger={handleSchemeLedger}
                                                setSchemeLedgerId={setSchemeLedgerId}
                                                searchParams={searchParams}
                                                setSearchParams={setSearchParams}
                                            />
                                            <Account
                                                AccountType={"Destination"}
                                                AccountOption={"single"}
                                                setSingleAccount={setDestinationAccount}
                                                singleAccount={destinationAccount}
                                                setSingleAccountId={setDestinationId}
                                                setSingleAccountNumber={setDestinationNumber}
                                                singleAccountNumber={destinationAccountNumber}
                                                singleAccountId={destinationId}
                                                setAccountNameError={setAccountNameError}
                                                accountNameError={accountNameError}
                                                amountError={amountError}
                                                setAmountError={setAmountError}
                                                setToastErrorMessage={setToastErrorMessage}
                                                LegerEndpoint={"RTE-Scholarship"}
                                                state={state}
                                                setSchemeStudentsData={setSchemeStudentsData}
                                                setstudentListLoading={setstudentListLoading}
                                                classKey={"w-[400px]"}
                                                handleSchemeLedger={handleSchemeLedger}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                            {openConfirmation &&
                                <AnimatedModel
                                    Children={
                                        <ConfirmationPrompt
                                            handleOnCLickActivate={handleFYSubmit}
                                            handleClose={() => setOpenConfirmation(false)}
                                            crossMark
                                            additionalMessage={`A Voucher is being created for '${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})', which appears to be a back-dated entry.`}
                                            message={`Do you want to continue?`}
                                            buttonName={`Continue`}
                                            tittle={'Back Dated Entry'}
                                            dialogueWidth={'500px'}
                                            textPosition={'text-start'}
                                            loadingActivation={activateButtonLoading}
                                        />
                                    }
                                />
                            }
                            {currentTab === 'step:2' && (
                                <SchemeStudentList
                                    schemeStudentsData={schemeStudentsData}
                                    setSchemeStudentsData={setSchemeStudentsData}
                                    setToastErrorMessage={setToastErrorMessage}
                                    sourceAccountId={sourceAccountId}
                                    sourceAccountNumber={sourceAccountNumber}
                                    appliedAmts={appliedAmts}
                                    setAppliedAmts={setAppliedAmts}
                                    studentListLoading={studentListLoading}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    searchParams={searchParams}
                                    setSearchParams={setSearchParams}
                                    schemeStudentsTotalcount={schemeStudentscount}
                                    setAppliedStudentsList={setAppliedStudentsList}
                                    appliedStudentsList={appliedStudentsList}
                                    state={state}
                                />
                            )}
                            {currentTab === 'step:3' && (
                                <AppliedStudentPreview
                                    appliedStudentsList={appliedStudentsList}

                                />
                            )}
                        </div>
                    </div>
                }

            </>

        </CardHeader >
    )
}
